import React 				from 'react';
import ReactDOM 			from 'react-dom';
import Masonry 				from 'react-masonry-component';
import BLComponent			from '../core/_BLComponent.jsx';
import StudioModel			from './StudioModel.jsx';
import MocCard 				from '../common/_MocCard.jsx';
import HiddenScroll 				from '../common/_HiddenScroll.jsx';
import EmptyState 				from '../common/_EmptyState.jsx';
import {GalleryIcon, AwardIcon} 		from '../common/_Icons.jsx';
import {CustomAlert}	from '../common/_Utilities.jsx';
import {StudioEvents}			from './_StudioEvents.jsx';
import StudioActivityContent from './_StudioActivityContent.jsx';


export default class StudioGallery extends BLComponent 
{
	constructor (props) 
	{
		super(props);

		this.state = 
			{
				page: 				1
			,	pageSize: 			50
			,	category: 			blapp.util.getUrlVar('tab') ? -1 : blapp.util.getUrlVar( 'cat' ) || 2000 //staff picks default
			,	searchQuery: 		blapp.util.getUrlVar( 's' ) || ''
			,	filters: 
				[
					{ type: 'published', method: 0 }
				,	{ type: 'sort', method: 4, direction: 1	}
				,	{ type:	'visibility', method: 0 }
				]
			,	models: 			blapp.models.get('models').arrModels
			,	totalModels: 		blapp.models.get('models').nTotalCnt
			,	idModel: 			blapp.util.getUrlVar( 'idModel' )
			,	altTerm:			null
			,	suggestedDesigners: []
			,	designerResult: []
			,	focusSearch: false
			,	modelSearchQuery: ''

			,	contestsActive: blapp.util.getUrlVar('tab') == 'activities' || false
			, showContestInfo: false
			,	activityList: blapp.models.get('activities') || []
			,	selectedActivity: this.getSelectedActivity()
			};
		
		this.funcSearchDesigners	= _.debounce( function ( query ) { this.searchDesigners() }.bind( this ), 1000 );
		this.masonryOptions 	= { transitionDuration: 0 };
		this.isRobot			= false;

		try 
		{ 
			const	userAgent = navigator.userAgent.toLowerCase();
			if ( userAgent.indexOf( "googlebot" ) >= 0
				|| userAgent.indexOf( "bingbot" ) >= 0
				|| userAgent.indexOf( "duckduckbot" ) >= 0
				|| userAgent.indexOf( "baiduspider" ) >= 0
				|| userAgent.indexOf( "yandexbot" ) >= 0
				|| userAgent.indexOf( "facebot" ) >= 0
				|| userAgent.indexOf( "ia_archiver" ) >= 0 )
			{
				this.isRobot = true;
			}
		} 
		catch ( e ) 
		{}
	}

	componentDidMount() 
	{
		this.registerPopStateCallback( ( e ) => this.onPopState( e ) );
		let	cFilters	= blapp.cookie.getLocalStorage( "galleryFilters" );

		if ( cFilters != null && cFilters != "" )
		{
			const arr = cFilters.split(",");
			const filters = [
				{ type: 'published', method: parseInt(arr[0]) }
			,	{ type: 'sort', method: parseInt(arr[1]), direction: parseInt(arr[2])	}
			,	{ type: 'visibility', method: parseInt(arr[3]) || 0 }
			]

			if(this.state.contestsActive) {
				this.setState({filters: filters}, () =>  this.loadModelsForContest())
			}else{
				this.setState({filters: filters}, () => (this.state.category != 2000 && this.state.category != -1) ? this.updateResults( 0 ) : null)
			}
		}else if(cFilters == null && blapp.util.getUrlVar('tab') == 'activities' && !blapp.util.getUrlVar('slug')) {
			this.setState({contestsActive: true, category: -1, models:[], selectedActivity: this.getActivities(true)}, () => this.loadModelsForContest());
		}

		if(blapp.util.getUrlVar( 's' ))
		{
			let url = window.location.href;
					url = blapp.util.removeParamFromUrl('s', url);

			window.history.pushState('', '', url)
		}

		window.addEventListener('keydown', (e) => {
			if(e.keyCode == 13 && this.state.searchQuery != '') {
				this.state.contestsActive ? this.loadModelsForContest() : this.updateResults(0);
			}
		});


		document.addEventListener('click', (event) => this.clickOutSearch(event));
	}

	componentWillUnmount() {
		document.removeEventListener('click', (event) => this.clickOutSearch(event));
	}

	clickOutSearch(event) {
		const isSearch = this.search && this.search.contains(event.target);

		if (!isSearch && this.state.focusSearch == true) {
			this.setState({ focusSearch: false });
		}
	}

	getSelectedActivity()
	{
		const slug = blapp.util.getUrlVar('slug');
		const activities = blapp.models.get('activities');

		const activity = activities.find(act => act.strWebSlug == slug);
		return  activity || activities[0];
	}

	render() 
	{
		const modelFunc	=	{
			setSearch: (strSearch) => this.updateSearchString(strSearch)
		};
		const mocs = 	this.state.models.filter(model => model && model.dmMainImage != null).map((model) => {

			if(model) {
				return <MocCard key={model && model.idModel} data={MocCard.getDataFromModel(model)} withIconBackground={model.listEventBadges} awards={this.getAwards(model)} func={modelFunc}/>
			}
		});

		return (
			<React.Fragment>
				<div className="main main--white">
					{this.state.idModel > 0 ? <StudioModel idModel={this.state.idModel} close={this.closeDetailModal} func={modelFunc}/> : null}
					<div className="main__content">
						{this.renderHeader()}

						{this.renderSearchBar()}
						{this.renderDesignerResults()}
						<div className="studio-gallery__nav">
							{this.renderCategoryTabs()}
						</div>
						
						{this.state.category != 2000 && !this.state.contestsActive && this.renderSearchFilters()}
						<div className="l-full-width overflow-hidden l-pad-y--sm">
								{this.state.category == 2000 ? 
									this.renderStaffPicks()
								:
								this.state.contestsActive ?
									this.renderContests()
								:
									<div className="studio-gallery__card-container">
										{mocs.length ? 
											<Masonry elementType={'div'} options={this.masonryOptions} disableImagesLoaded={false}>
												{mocs}
											</Masonry>
										: 
											<div className="l-pad-y--xl text--center">
												<EmptyState type="scared" classes="empty-state--light l-pad-bottom--sm" title="It's lonely in here"/>
												<p>Help us out by <a href={blapp.url2.getStudioMyStudioUrl()}>uploading your design</a>.</p>
											</div>
										}
									</div>
								}
						</div>
						<div className="l-flex l-center-v l-margin-top l-margin-bottom--xl">
							{this.state.totalModels > this.state.models.length ? <button className="btn btn--cta l-pad" data-ts-name="studio-gallery-feed__load-more" onClick={() => this.loadMore()}>{$T("LOAD_MORE_CREATIONS")}</button>: null}
							{this.isRobot ? <a className="btn btn--cta-outline l-pad" data-ts-name="studio-gallery-feed__show-all" href={blapp.url2.getGeneralUrl( "/studio/gallery_all.page" )}>SHOW ALL</a> : null}
						</div>
					</div>
				</div>
			</React.Fragment>
		);
	}

	renderHeader() {
		return (
			<section className="edge-to-edge-container studio-gallery__header">
				<div className="edge-to-edge-container__internal studio-gallery__header-internal">
					<div className="studio-gallery__header-content">
						<h2 className="studio-gallery__header-tag">{$T("STUDIO_GALLERY")}</h2>
						<p className="studio-gallery__header-text">Explore, share, and download custom creations</p>
						<div className="l-margin-top--auto l-flex l-center">
							<a className="btn btn--yellow btn--lemon l-inline-block text--bold" data-ts-name="studio-gallery-head__upload" href={blapp.url2.getStudioModelUploadUrl('studio-gallery')}>
								Upload creation
							</a>
							<button className="btn btn--blank l-flex l-center text-color--lemon l-margin-left" data-ts-name="studio-gallery-head__my-gallery" onClick={() => this.goToMyGallery()}>
								Go to My Gallery
							</button>
						</div>
					</div>
					<div className="studio-gallery__header-image">
						<img className="l-block" src={"//" + blapp.config.getHost( "static2" ) + "/img/studio-gallery/mech_header.png"} alt="Full Mechimal Combiner! - by Zoingo"/>
					</div>
				</div>
			</section>
		);
	}

	updateFilters(type, method, value) {
		const filters = this.state.filters;
		filters[type][method] = parseInt(value);
		
		let filterStr = `${filters[0].method},${filters[1].method},${filters[1].direction},${filters[2].method}`;
		blapp.cookie.setLocalStorage( "galleryFilters", filterStr );

		if( !this.state.contestsActive ) {
			this.setState({filters: filters}, () => this.updateResults(0));
		}else {
			this.setState({filters: filters}, () => this.loadModelsForContest());
		}
	}

	renderCategoryTabs() 
	{
		const categories = [
				{name: $T("STAFF_PICKS"), value: 2000}
			,	{name: $T("POPULAR"), value: 0}
			,	{name: $T("VEHICLE"), value: 1}
			,	{name: $T("SPACE"), value : 3}
			,	{name: $T("MECHA"), value : 4}
			,	{name: $T("BUILDING"), value : 5}
			,	{name: $T("ANIMAL"), value : 6}
			,	{name: $T("CHARACTER"), value : 7}
			,	{name: $T("SEASONAL"), value : 8}
			,	{name: $T("LIFE"), value : 9}
			,	{name: $T("MISC"), value : 10}
		];

		const categoryItems = categories.map((category, key) => 
			<li key={key} data-ts-name="studio-gallery-tab" data-ts-id={category.value} className={"view-selector__item" + (this.state.category == category.value ? " view-selector__item--active" : "") + (category.value == 2000 ? ' studio-staff-picks__tab' : '')} onClick={this.state.category != category.value ? () => this.updateCategory(category.value) : null}>
				<span className="view-selector__item-content">{category.value == 2000 ? <i className="fa-fw far fa-crown studio-staff-picks__tab-icon l-margin-right--sm"/> : null}{category.name}</span>
			</li>
		);

		categoryItems.splice(1, 0, <li key={'contest'} data-ts-name="studio-gallery-tab" data-ts-id="activities" className={"view-selector__item studio-activities__tab" + (this.state.contestsActive ? " view-selector__item--active" : "")} onClick={() => this.selectContests()}>
			<span className="view-selector__item-content">Activities</span>
		</li>);

		return (
			<ul className="view-selector view-selector--bordered studio-gallery__tabs">
				{categoryItems}
			</ul>
		);
	}

	selectContests() {
		window.history.pushState(history.state, "", `?tab=activities`);
		this.setState({modelSearchQuery: '', searchQuery: '', contestsActive: true, category: -1, models:[], selectedActivity: this.getActivities(true)}, () => this.loadModelsForContest());
	}

	renderSearchFilters(subtract = 0) {
		const {method: sortMethod, direction: sortDirection} = this.state.filters[1];
		const {method: publishMethod} = this.state.filters[0];
		const {method: visibility } = this.state.filters[2]

		return (
			<div className={"studio-gallery__filters" + (this.state.category == 2000 ? ' studio-gallery__filters--staff-picks' : '')}>
				{this.state.modelSearchQuery ? 
					<p className="studio-gallery__results-count">
						{this.state.totalModels} {$T("SEARCH_RESULTS_FOR")} "<strong data-ts-name="studio-gallery-results__search-value">{this.state.modelSearchQuery}</strong>"
					</p> 
				: 
					<p className="studio-gallery__results-count" data-ts-name="studio-gallery-results__count">
						<strong>{this.state.totalModels - subtract} creation{this.state.totalModels - subtract != 1 ? 's' : ''}</strong>
					</p>
				}
				{!this.state.contestsActive &&
					<div className="l-flex l-center studio-gallery__filters-show">
						<p className="l-margin-right--sm">Show:</p>
						<select className="select select--x-tight studio-gallery__filter-item" data-ts-name="studio-gallery-results__filter--show" value={visibility} onChange={(e) => this.updateFilters(2, 'method', e.target.value)}>
							<option value={0}>All designs</option>
							<option value={1}>For display only</option>
							<option value={2}>Downloadable</option>
						</select>
					</div>
				}
				<div className={`l-flex l-center studio-gallery__filters-sort ${this.state.contestsActive ? ' studio-gallery__filters-sort--no-show' : ''}`}>
					<p className="l-margin-right--sm l-hide--small">Sort:</p>
					<div className="sort-lockup studio-gallery__filter-item studio-gallery__filter-item--sort">
						<button className="btn sort-lockup__direction" data-ts-name="studio-gallery-results__filter--sort-direction" onClick={(e) => this.updateFilters(1, 'direction', sortDirection == 1 ? 2 : 1)}><i className={"fas " + (sortDirection == 1 ? 'fa-sort-amount-down' : 'fa-sort-amount-up')}/></button>
						<select className="select sort-lockup__select" value={sortMethod} onChange={(e) => this.updateFilters(1, 'method', e.target.value)} data-ts-name="studio-gallery-results__filter--sort">
							<option value={4}>{$T("RECENTLY_LIKED")}</option>
							<option value={1}>{$T("TOTAL_LIKES")}</option>
							<option value={5}>{$T("PUBLISH_DATE")}</option>
							<option value={2}>{$T("VIEWS")}</option>
							<option value={3}>{$T("DOWNLOADS")}</option>
						</select>
					</div>

					<select className="select select--tight l-margin-left--sm bg-color--white studio-gallery__filter-item" data-ts-name="studio-gallery-results__filter--publish-time" value={publishMethod} onChange={(e) => this.updateFilters(0, 'method', e.target.value)}>
						<option value={1}>{$T("PAST_24")}</option>
						<option value={2}>{$T("PAST_WEEK")}</option>
						<option value={3}>{$T("PAST_MONTH")}</option>
						<option value={0}>{$T("ANYTIME")}</option>
					</select>
				</div>
			</div>
		);
	}

	renderSearchBar() 
	{
		const {suggestedDesigners} = this.state;
		const designers = [...suggestedDesigners].slice(0, 3).map((designer, key) => {
			return (
				<li className="studio-gallery__search-suggestions-item" key={designer.dmUser.idUser}>
					<a href={blapp.url2.getStudioPublicGalleryUrl(designer.dmUser.idUser)} data-ts-name="designer-card" className="designer-card">
						<div className="designer-card__profile">
							<div className="designer-card__image">
								<img src={blapp.url2.getProfileImgUrl(designer.dmUser,'small')} className="designer-card__image-content" data-ts-name="designer-card__image"/>
							</div>
							{designer.stats.nTypeBadge > 0 && <div className="designer-card__award" data-ts-name="designer-card__award"><AwardIcon source={'card'} award={designer.stats.nTypeBadge} background/></div>}
						</div>
						<header className="designer-card__details" data-ts-name="designer-card__details">
							<div className="designer-card__name">{designer.dmUser.skUsername}</div>
							<div className="designer-card__creations">{`${designer.stats.nPublicCreations} ${designer.stats.nPublicCreations > 1 ? 'creations' : 'creation'}`}</div>
						</header>
					</a>
				</li>
			);
		});

		return (
			<div className="studio-gallery__search" ref={(search) => this.search = search}>
				<div className="search-lockup search-lockup--bordered studio-gallery__search-bar">
					<div className={"search-lockup__input-container" + (this.state.focusSearch ? ' search-lockup__input-container--focus' : '')}>
						<input id="searchBox" type="text" data-ts-name="studio-gallery__search-input" className="search-lockup__input search-lockup__input--start" onFocus={() => this.setState({focusSearch: true})} placeholder={$T("SEARCH")} value={this.state.searchQuery} onChange={(e) => this.updateSearchString(e.target.value)}/>
						{this.state.searchQuery && 
							<button className="btn btn--blank" data-ts-name="studio-gallery__search-clear" onClick={() => this.updateSearchString('')}>
								<i className="fas fa-times-circle search-lockup__btn--clear"/>
							</button>
						}
						<button className="search-lockup__btn search-lockup__btn--end" data-ts-name="studio-gallery__search-cta" onClick={() => this.state.contestsActive ? this.loadModelsForContest() : this.updateResults(0)}><i className="far fa-search search-lockup__btn-icon"/></button>
					</div>
				</div>
				<div className={"studio-gallery__search-suggestions" + (this.state.focusSearch && suggestedDesigners.length ? " studio-gallery__search-suggestions--show" : '')} data-ts-name="studio-gallery__search-designers">
					<strong className="l-margin-bottom--sm">Designer results</strong>
					<ul>
						{designers}
						{suggestedDesigners.length > 3 ? 
							<li className="studio-gallery__search-suggestions-item studio-gallery__search-suggestions-item--cta">
								<button className="btn btn--link text--bold" data-ts-name="studio-gallery__search-designer-all" onClick={() => this.updateResults(0)}>Search all</button>
							</li> 
						: null}
					</ul>
				</div>
			</div>
		);
	}

	renderDesignerResults() {
		const {designerResult} = this.state;

		const designers = designerResult.map((designer, key) => {
			return (
				<div className="l-margin-right">
					<a href={blapp.url2.getStudioPublicGalleryUrl(designer.dmUser.idUser)} data-ts-name="results-designer-card" className="designer-card designer-card--bordered">
						<div className="designer-card__profile">
							<div className="designer-card__image">
								<img src={blapp.url2.getProfileImgUrl(designer.dmUser,'small')} data-ts-name="results-designer-card__image-content" className="designer-card__image-content"/>
							</div>
							{designer.stats.nTypeBadge > 0 && <div className="designer-card__award" data-ts-name="results-designer-card__award"><AwardIcon source={'card'} award={designer.stats.nTypeBadge} background/></div>}
						</div>
						<header className="designer-card__details" data-ts-name="results-designer-card__details">
							<div className="designer-card__name">{designer.dmUser.skUsername}</div>
							<div className="designer-card__creations">{`${designer.stats.nPublicCreations} ${designer.stats.nPublicCreations > 1 ? 'creations' : 'creation'}`}</div>
						</header>
					</a>
				</div>
			);
		});

		if(designers.length) {
			return (
				<div className="l-margin-bottom--xl">
					{this.state.modelSearchQuery && <p className="l-margin-bottom--sm"><strong>{designers.length}</strong> designer result{designers.length != 1 ? 's' : ''} for "<strong>{this.state.modelSearchQuery}</strong>"</p>}
					<HiddenScroll>
						{designers}
					</HiddenScroll>
				</div>
			);
		}
	}

	getAwards(model)
	{
		let awards = []
		if(model.nTypeBadge > 0)
			awards.push(model.nTypeBadge)

		if(model.listEventBadges)
			awards.push(StudioEvents(model.listEventBadges[0]))
			
		return awards;
	}

	renderStaffPicks() {
		const modelFunc	=	{
			setSearch: (strSearch) => this.updateSearchString(strSearch)
		};
		const pastDate = this.getLastWeek().getTime();

		const currentPicks 	= 	[...this.state.models].map((model) => {if(model && model.udtStaffPicked >= pastDate) return <MocCard key={model && model.idModel} data={MocCard.getDataFromModel(model)} awards={this.getAwards(model)} func={modelFunc}/>; else return null}).filter( m => m != null);
		const prevPicks 	= 	[...this.state.models].map((model) => {if(model && model.udtStaffPicked < pastDate) return <MocCard key={model && model.idModel} data={MocCard.getDataFromModel(model)} awards={this.getAwards(model)} func={modelFunc}/>; else return null}).filter( m => m != null);
		return (
			<div className="studio-gallery__card-container">
				{currentPicks.length > 0 &&
					<React.Fragment>
						<div className="studio-staff-picks__bar l-margin-top--md">
							This week's picks
						</div>
						<Masonry elementType={'div'} options={this.masonryOptions} disableImagesLoaded={false}>
							{currentPicks}
						</Masonry>
					</React.Fragment>
				}
				{prevPicks.length > 0 &&
					<React.Fragment>
						<div className="l-margin-y text-divider">
							<p className="text-divider__text text-color--darkestBlue text--bold">Previous week's picks</p>
						</div>
						<Masonry elementType={'div'} options={this.masonryOptions} disableImagesLoaded={false}>
							{prevPicks}
						</Masonry>
					</React.Fragment>
				}
				{this.state.totalModels <= this.state.models.length ?
					<div className="l-flex l-center-v l-margin-top--xl">
						<div className="studio-gallery__browse-more" data-ts-name="show-contest__staff-picks-more-container">
							<p className="studio-gallery__browse-more-text">You've reached the end of Staff Picks.</p>
							<button className="btn btn--cta text--bold l-inline-block" data-ts-name="show-contest__staff-picks-more" onClick={() => this.browseMore()}>Browse popular creations</button>
						</div>
					</div>
					:
					null
				}
			</div>
		);
	}

	isContestWinner = (model) =>
	{
		let idContest = this.state.selectedActivity.idEvent;
		return model.listEventBadges && model.listEventBadges.find( e => e.idEvent == idContest && e.nWinner > 0);		
	}

	sortWinners = (a,b) =>
	{
		let idContest = this.state.selectedActivity.idEvent;
		let ea = a.listEventBadges.find( e => e.idEvent == idContest );
		let eb = b.listEventBadges.find( e => e.idEvent == idContest );

		if (ea.nWinner < eb.nWinner)
			return -1;
		else
			return 1;
	}

	renderContests() {
		const modelFunc	=	{
			setSearch: (strSearch) => this.updateSearchString(strSearch)
		};

		const contestEntries = [...this.state.models].filter(model => !this.isContestWinner(model)).map((model) => {
			return (
				<MocCard key={model && model.idModel} data={MocCard.getDataFromModel(model)} withIconBackground awards={this.getAwards(model)} func={modelFunc}/>
			);
		}).filter( m => m != null);

		const contestWinners = [...this.state.models.filter(this.isContestWinner).sort(this.sortWinners)].map((model) => {
			return (
				<MocCard key={model && model.idModel} data={MocCard.getDataFromModel(model)} withIconBackground awards={this.getAwards(model)} func={modelFunc}/>
			);
		}).filter( m => m != null);

		const contestName = this.state.selectedActivity.strEventName;
		const contestSlug = this.state.selectedActivity ? this.state.selectedActivity.strWebSlug : 'project-acorn';

		const showWinners = blapp.config.server_time >= this.state.selectedActivity.udtWinDate;

		return (
			<section data-ts-name="studio-contest">
				<header className="l-flex l-margin-bottom l-margin-top--sm">
					<label className="l-margin-left--auto">
						<strong>View:</strong>
						<select className="select select--tight l-margin-left--sm" data-ts-name="studio-contest__select" onChange={(e) => this.changeActivity(e.target.value)} value={this.state.selectedActivity.strWebSlug}>
							{this.state.activityList.map(activity => <option value={activity.strWebSlug}>{activity.strEventName}</option>)}
						</select>
					</label>
				</header>
				<StudioActivityContent activity={this.state.selectedActivity} slug={contestSlug}/>
				{(showWinners && contestWinners.length > 0) &&
					<React.Fragment>
						<div className="text--bold text--xl-title l-margin-bottom--l text--center l-margin-top--xxl"  data-ts-name="studio-contest__winners-title">
							🎉 Winners of {contestName}
						</div>
						<div className="studio-gallery__card-container" data-ts-name="studio-contest__winners">
							<Masonry elementType={'div'} options={this.masonryOptions} disableImagesLoaded={false}>
								{contestWinners}
							</Masonry>
							<div className="l-margin-bottom--l l-margin-top--xl text-divider">
								<p className="text-divider__text text-color--darkestBlue text--bold">Remaining Entries</p>
							</div>
						</div>
					</React.Fragment>
				}
				{this.renderSearchFilters(contestWinners.length)}
				<div data-ts-name="studio-contest__entries" className="studio-gallery__card-container">
					<Masonry elementType={'div'} options={this.masonryOptions} disableImagesLoaded={false}>
						{contestEntries}
					</Masonry>
				
					{this.state.totalModels <= this.state.models.length ?
						<div className="l-flex l-center-v l-margin-top--xl">
							<div className="studio-gallery__browse-more" data-ts-name="show-contest__browse-more-container">
								<p className="studio-gallery__browse-more-text">You've reached the end of {this.state.selectedActivity.strEventName} submissions.</p>
								<button className="btn btn--cta text--bold l-inline-block" data-ts-name="show-contest__browse-more" onClick={() => this.browseMore()}>Browse popular creations</button>
							</div>
						</div>
						:
						null
					}
				</div>
			</section>
		);
	}

	browseMore() {
		this.updateCategory(0)
		$('body, html').animate({scrollTop: 0}, 100);
	}

	goToMyGallery()
	{
		if ( blapp.session.isLoggedIn() )
		{
			window.location.href = blapp.url2.getStudioPublicGalleryUrl(blapp.session.getUserID());
		}
		else
		{
			blapp.refs.get( "header" ).showLogin( 
				() => 
				{ 
					if ( blapp.session.isLoggedIn() )
						window.location.href = blapp.url2.getStudioPublicGalleryUrl(blapp.session.getUserID());
				} 
			);
		}
	}

	updateCategory(key)
	{
		window.history.pushState(history.state + key, "", `?cat=${key}`);
		this.setState({category: parseInt(key), contestsActive: false, models:[]}, ()=> this.updateResults(0))
	}

	updateSearchString(query)
	{
		if ( query.length < 3 && query !== '')
		{
			this.setState({searchQuery: query});
		}
		else
		{
			this.setState({searchQuery: query});
			this.funcSearchDesigners(query);
		}
	}

	triggerAlert(message) 
	{
		const confirmContent = `<i class="text-color--primaryRed fas fa-exclamation-triangle l-margin-bottom" data-ts-name="alert--error"></i>
		<p class="text-color--primaryRed">${message}</p>`;

		CustomAlert(confirmContent);
	}

	updateResults(option)
	{
		const filters = [
			option == 0 ? 1 : this.state.page + 1,
			this.state.pageSize,
			this.state.category == 2000 ? 8 : this.state.filters[1].method,
			this.state.filters[1].direction,
			this.state.category == 2000 ? 0 : this.state.filters[0].method,
			this.state.category == 2000 ? 0 : this.state.filters[2].method,
			this.state.category,
			this.state.searchQuery.trim(),
			0 
		]
		blapp.models.fetch
		(
			"_updateGallerySearch"
		,	{
				controller:	"studio.BLCUserModel"
			,	method:		"getModelList"
			,	params:		filters
			,	refresh:	true
			}
		).then(
        	(data) =>
            {
				if(data !== null){
					if(option == 1){
						this.setState(prevState => ({
							models: prevState.models.concat(data.arrModels),
							page: prevState.page + 1,
							totalModels: data.nTotalCnt,
							modelSearchQuery: this.state.searchQuery,
							altTerm:data.altTerm,
							focusSearch: false,
							designerResult: this.state.suggestedDesigners
						}))
					}
					else{
						this.setState(prevState => ({
							models: data.arrModels,
							page: 1,
							totalModels: data.nTotalCnt,
							modelSearchQuery: this.state.searchQuery,
							altTerm: data.altTerm,
							focusSearch: false,
							designerResult: this.state.suggestedDesigners
						}))
					}
					document.getElementById("searchBox").blur();
				}
                else{
					this.triggerAlert('Error loading models')
				}
            }
        ).catch( 
        	(error) =>
            {	
				console.log(error)
				this.triggerAlert('Error loading models')
            }
        );
	}

	loadMore()
	{
		this.updateResults(1)
	}

	changeActivity(slug) {
		window.history.pushState(history.state, "", `?tab=activities&slug=${slug}`);
		const activity = this.state.activityList.find(act => act.strWebSlug == slug);
		this.setState({contestsActive: true, category: -1, selectedActivity: activity || this.getActivities(true), models:[]}, () => this.loadModelsForContest());
	}

	getActivities(last) {
		const activities = this.state.activityList;

		if(last) {
			return activities[0];
		}
		
		return activities;
	}

	loadModelsForContest()
	{
		const slug = blapp.util.getUrlVar('slug') ? blapp.util.getUrlVar('slug') : this.getActivities(true).strWebSlug;

		blapp.models.fetch
		(
			"_loadModelsForContest"
		,	{
				controller:	"studio.BLCGalleryEvents"
			,	method:		"getModelsFromSlug"
			,	params:		[slug, this.state.filters[0].method, this.state.filters[1].method, this.state.filters[1].direction, this.state.searchQuery.trim()]
			,	refresh:	true
			}
		).then(
        	(data) =>
            {
				if(data !== null){
					this.setState(prevState => ({
						models: data.arrModels
					,	totalModels: data.nTotalCnt
					}))
				}
                else{
					this.triggerAlert('Error loading models')
				}
            }
        ).catch( 
        	(error) =>
            {	
				console.log(error)
				this.triggerAlert('Error loading models')
            }
        );
	}

	searchDesigners()
	{
		blapp.models.fetch
		(
			"_updateGallerySearchDesigners"
		,	{
				controller:	"studio.BLCUserModel"
			,	method:		"searchDesigners"
			,	params:		[this.state.searchQuery.trim()]
			,	refresh:	true
			}
		).then(
        	(data) =>
            {
				if(data !== null){
					this.setState(prevState => ({
						suggestedDesigners: data
					}))
				}
                else{
					this.triggerAlert('Error loading designers')
				}
            }
        ).catch( 
        	(error) =>
            {	
				console.log(error)
				this.triggerAlert('Error loading designers')
            }
        );
	}


	closeDetailModal = () =>
	{
		this.setState({ idModel: null });
	}

	onPopState( e )
	{
		const	urlInfo		= blapp.util.getUrlInfo( window.location.href );
		const	galleryUrl	= blapp.util.getUrlInfo( blapp.url2.getStudioGalleryUrl() );
		const	modelUrl	= blapp.util.getUrlInfo( blapp.url2.getStudioModelUrl( 1 ) );

		if ( urlInfo.path == galleryUrl.path )
		{
			this.setState( { idModel: null } );
			if(blapp.util.getUrlVar('tab') == 'activities') {
				const activity = this.state.activityList.find(act => act.strWebSlug == blapp.util.getUrlVar('slug'));
				this.setState({category: -1, contestsActive: true,  selectedActivity: activity || this.getActivities(true)})
			}else if(blapp.util.getUrlVar( 'cat' ) || this.state.category != 0) {
				this.setState({category: parseInt(blapp.util.getUrlVar( 'cat' ) || 0)}, ()=> this.updateResults(0))
			}
		}
		else if ( urlInfo.path == modelUrl.path )
		{
			const	idModel	= parseInt( blapp.util.getUrlVar( "idModel" ) );

			if ( idModel > 0 )
				this.setState( { idModel: idModel } );
		}
	}

	getLastWeek() {
		var today = new Date();
		var lastWeek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
		return lastWeek;
	}
};

document.addEventListener(
	"DOMContentLoaded", 
	function() 
	{
		var	elem	=	ReactDOM.render(
							<StudioGallery blctx={{parent: null, idx:0}} />
						,	document.getElementById( 'bl-studio-gallery' )
						);
		blapp.refs.register( "main", elem );
	}
);

var $T = BLComponent.createTextMap( 
		{
			"STUDIO_GALLERY":
			{
				"en":	"Studio Gallery"
			,	"kr":	"스튜디오 갤러리"
			,	"es":	"Galería"
			}
		,	"MY_GALLERY":
			{
				"en":	"Go to My Gallery"
			,	"kr":	""
			,	"es":	""
			}
		,	"SEARCH_RESULTS_FOR":
			{
				"en":	"search results for ",
				"kr":	"검색 키워드",
				"es":	"busca resultados para "
			}
		,	"LOAD_MORE_CREATIONS":
			{
				"en":	"Load more creations",
				"kr":	"",
				"es":	""
			}
		,	"SEARCH":
			{
				"en":  "Search by creation name or designer"
			,	"kr":  ""
			,	"es":  ""
			}
		,	"RECENTLY_LIKED":
			{
				"en":	"Recently liked"
			,	"kr":	"최근 좋아요 순"
			,	"es":	"Gustados recientemente"
			}
		,	"TOTAL_LIKES":
			{
				"en":	"Total likes"
			,	"kr":	"총 좋아요 순"
			,	"es":	"Más gustados"
			}
		,	"PUBLISH_DATE":
			{
				"en":	"Published date"
			,	"kr":	"발행 일자 순"
			,	"es":	"Fecha de publicación"
			}
		,	"VIEWS":
			{
				"en":	"Views"
			,	"kr":	"보기 순"
			,	"es":	"Visitas"
			}
		,	"DOWNLOADS":
			{
				"en":	"Downloads"
			,	"kr":	"다운로드 순"
			,	"es":	"Descargas"
			}
		,	"PAST_24":
			{
				"en":	"Past 24 hours"
			,	"kr":	"최근 24시간"
			,	"es":	"Últimas 24 horas"
			}
		,	"PAST_WEEK":
			{
				"en":	"Past week"
			,	"kr":	"최근 일주일"
			,	"es":	"Última semana"
			}
		,	"PAST_MONTH":
			{
				"en":	"Past month"
			,	"kr":	"최근 한 달"
			,	"es":	"Último mes"
			}
		,	"ANYTIME":
			{
				"en":	"Any time"
			,	"kr":	"전체 시간"
			,	"es":	"Cualquier momento"
			}
		,	"ADP":
			{
				"en":	"AFOL Designer Program",
				"kr":	"",
				"es":	""
			}
		,	"STAFF_PICKS":
			{
				"en":	"Staff Picks",
				"kr":	"",
				"es":	""
			}
		,	"POPULAR":
			{
				"en":	"Popular",
				"kr":	"인기",
				"es":	"Popular"
			}
		,	"ADP":
			{
				"en":	"AFOL Designer Program",
				"kr":	"",
				"es":	"AFOL Designer Program"
			}
		,	"VEHICLE":
			{
				"en":	"Vehicle",
				"kr":	"차량",
				"es":	"Vehículo"
			}
		,	"SPACE":
			{
				"en":	"Space",
				"kr":	"우주",
				"es":	"Espacio"
			}
		,	"MECHA":
			{
				"en":	"Mecha",
				"kr":	"메카",
				"es":	"Mecha"
			}
		,	"BUILDING":
			{
				"en":	"Building",
				"kr":	"건축물",
				"es":	"Edificio"
			}
		,	"ANIMAL":
			{
				"en":	"Animal",
				"kr":	"동물",
				"es":	"Animal"
			}
		,	"CHARACTER":
			{
				"en":	"Character",
				"kr":	"캐릭터",
				"es":	"Personaje"
			}
		,	"SEASONAL":
			{
				"en":	"Seasonal",
				"kr":	"시즌",
				"es":	"De temporada"
			}
		,	"LIFE":
			{
				"en":	"Life",
				"kr":	"일상",
				"es":	"Vida"
			}
		,	"MISC":
			{
				"en":	"Misc",
				"kr":	"기타",
				"es":	"Otros"
			}	
		,	"SORT_BY":
			{
				"en":	"Sort by:",
				"kr":	"정렬:",
				"es":	"Ordenar por:"
			}	
		,	"PUBLISHED":
			{
				"en":	"Published:",
				"kr":	"발행일:",
				"es":	"Publicado:"
			}	
	}
);
 

